import "../css/404.css";
const Page404 = () => {

    return(
        <div className="lost-page">
            <div className="lost-big">
                <span>4</span>
                <span className="lost-icon"></span>
                <span>4</span>
                <br/>
                <h1>there nothing here</h1>
            </div>
        </div>
    )
}
export default Page404;